<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group :label="$t('FIRST_NAME')">
          <b-form-input v-model="userData.first_name" type="text"></b-form-input>
          <validation-description :show="$v.userData.first_name.$dirty && $v.userData.first_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('LAST_NAME')">
          <b-form-input v-model="userData.last_name"  type="text"></b-form-input>
          <validation-description :show="$v.userData.last_name.$dirty && $v.userData.last_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('ROLES')">
          <b-form-select v-model="userData.role.id">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.role.id.$dirty && $v.userData.role.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('ECONOMY')">
          <b-form-select v-model="userData.economy.id">
            <option :value="null">-</option>
            <option :key="index" v-for="(economy, index) in economics" :value="economy.id">
              {{ economy.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.economy.id.$dirty && $v.userData.economy.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('INSTITUTION')">
          <b-form-select v-model="userData.institution.id" :disabled="disabledInstitution()">
            <option :value="null">-</option>
            <option :key="index" v-for="(institution, index) in institutions" :value="institution.id">
              {{institution.name}}
            </option>
          </b-form-select>
          <validation-description v-if="!disabledInstitution()" :show="$v.userData.institution.$dirty && $v.userData.institution.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group :label="$t('LANGUAGE')">
          <b-form-select v-model="userData.preferred_language" :options="language_options">
          </b-form-select>
          <validation-description :show="$v.userData.preferred_language.$dirty && $v.userData.preferred_language.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-form-group :label="$t('STATUS')">
         <b-form-select :options="options_status" v-model="userData.is_active"></b-form-select>
        </b-form-group>
        <validation-description :show="$v.userData.is_active.$dirty && $v.userData.is_active.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </validation-description>
      </b-col>
    </b-row>
    <b-row>
        <b-col>
          <app-button-submit :loading="loading_save" :c_permission="C_USER_EDIT_BUTTON"></app-button-submit>
        </b-col>
        <b-col>
          <delete-button :c_permission="C_USER_DELETE_BUTTON"
                         @click="showDeleteDialog=true"
                         class="pull-right">
          </delete-button>
          <app-button :loading="loadingReset" variant="primary" class="ml-3 pull-right" @click="resendToken">{{$t('RESET_PASSWORD')}}</app-button>

          <confirmation-dialog :show="showDeleteDialog" @confirm="deleteApp" @cancel="showDeleteDialog=false"> </confirmation-dialog>
        </b-col>
    </b-row>

  </b-form>
</template>

<script>
  import _findKey from 'lodash/findKey'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ConfirmationDialog from '@/components/app/form/AppConfirmationDialog'
  import DeleteButton from '@/components/app/AppDelete'
  import {getInstitutionList} from "@/services/institution";
  import {getEconomyList} from "@/services/economy"
  import {getRoleList} from "@/services/role"
  import {updateUser} from "@/services/user";
  import {toast} from "@/shared/plugins/toastr";
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {createUser, getUser,resendTokenToUser} from "@/services/user";
  import {deleteUser} from "@/services/user";
  import enumeration from "@/store/enumeration"
  import i18n from '@/locale/index'
  import AppButton from "@/components/app/AppButton";
  import {C_USER_EDIT_BUTTON} from "@/shared/component_permission";
  import {C_USER_DELETE_BUTTON} from "@/shared/component_permission";

  export default {
    name: "user-edit-form",
    props:{
      id:{
        type:Number
      },
      userList:{
        type:Array,
        default:[]
      },
    },
    mixins:[getErrorMessage],
    data() {
      return {
        C_USER_EDIT_BUTTON,
        C_USER_DELETE_BUTTON,
        showDeleteDialog:false,
        select: this.selected,
        editAsidePanel:'',
        options_status:[
          {value:null, text:'-'},
          {value:1, text: i18n.t('ACTIVE')},
          {value:0, text: i18n.t('NOTACTIVE')}
        ],
        userData:{
          id:null,
          first_name:null,
          last_name:null,
          email:null,
          preferred_language:null,
          password:null,
          institution:{
            id:null,
            name:null
          },
          economy:{
            id:null,
            name:null
          },
          role:{
            id:null,
          },
          is_active:null
        },
        institutions:[],
        economics:[],
        roles:[],
        loadingReset:false,
        loading_save:false,
        language_options:[
          {
            value:'en',text:this.$t('ENGLISH'),
          },
          {
            value:'srb_sr',text:this.$t('SERBIAN'),
          },
          {
            value:'bs',text:this.$t('BOSNIAN_BOS'),
          },
          {
            value:'hr',text:this.$t('BOSNIAN_HRV'),
          },
          {
            value:'sr',text:this.$t('BOSNIAN_SRP'),
          },
          {
            value:'en',text:this.$t('MACEDONIAN'),
          },
          {
            value:'en',text:this.$t('ALBANIAN'),
          },
          {
            value:'bs',text:this.$t('MONTENEGRO'),
          }
        ],
      }
    },
    editAsidePanel: false,
    components:{
      AppButton,
      AppButtonSubmit,
      DeleteButton,
      ConfirmationDialog,
      ValidationDescription

    },
    computed:{
       userIndex(){
         if(!this.id){
           null
         }
         let userList =  this.$store.getters['user/getSearchList']
         let index = _findKey(userList, (el)=>{
           return el.id === this.id
         })
         return index
       },
       user(){
         return  this.$store.getters['user/getSearchList'][this.userIndex]
       },

    },
    validations(){
      return this.disabledInstitution()
      ? {
      userData:{
        first_name:{required},
        last_name:{required},
        email:{required},
        preferred_language:{required},
        is_active:{required},
        role: {
           id:{required},
        },
        economy:{
          id:{required}
        }
      }
    }
    : {
      userData:{
        first_name:{required},
        last_name:{required},
        email:{required},
        preferred_language:{required},
        institution:{
          id:{required}
        },
        is_active:{required},
        role: {
           id:{required},
        },
        economy:{
          id:{required}
        }
      }
     }
    },
    methods:{
      resendToken(){
        this.loadingReset= true
        resendTokenToUser(this.userData.id).then(response => {
          toast({
            title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$store.dispatch('user/actionSearch')
          setTimeout(() => {
            this.$emit('closePanel', this.editAsidePanel)
          }, 500)
        }, () => {
          toast({
            title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
            message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=>{
            this.loadingReset = false
        })
      },
      save(){
        this.$v.userData.$touch()
        if(this.$v.userData.$invalid){
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 4000
          })
          return
        }
        this.loading_save= true
          updateUser(this.userData.id, this.userData)
            .then(()=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
                this.$store.dispatch('user/actionSearch')
                this.$emit('closePanel', this.editAsidePanel)

            }, error=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                'type': 'error',
                'timeout': 6000
              })
          }).finally(()=>{
            this.loading_save = false
          })
      },
      deleteApp(){
        deleteUser(this.userData.id)
          .then(response => {
              this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
            this.$store.dispatch('user/actionSearch')
            setTimeout(() => {
              this.$emit('closePanel', this.editAsidePanel)
            }, 500)

          },error => {
              toast({
                'title': "Delete  fail",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            })
      },
      getInstitutions(id){
        getInstitutionList({economy:id})
          .then(response => {
            this.institutions = response.data
          })
      },
      getEconomies() {
        getEconomyList()
            .then(response => {
              this.economics = response.data
          })
      },
      getRoles() {
          let roleList = []
          getRoleList()
             .then(response => {
               roleList = response.data
               this.roles = roleList.slice(1,4)
          })
      },
      disabledInstitution() {
          if(this.userData.role.id === enumeration.economy_view_role) {
           return true
          }
           return false
        },
    },
    watch:{
      'userData.economy.id':{
          handler(value) {
              this.getInstitutions(value)
          }
       }
    },
    created(){
      this.getEconomies()
      this.getRoles()
      this.userData = this.user
    }
  }
</script>

<style scoped>

</style>
